import { useEffect, useState } from 'react';
import { adminClientService } from '../../services/adminClientService';

/**
 * Un conto Cliente, scelto cercando per ragione sociale, partita IVA o conto,
 * o scritto direttamente. Per l'Aggiornamento diretto di un conto.
 */
export default function ContoCombobox({ valore, onChange, onInvio }: {
  valore: string;
  onChange: (conto: string) => void;
  onInvio: () => void;
}) {
  const [aperta, setAperta] = useState(false);
  const [opzioni, setOpzioni] = useState<{ conto: number; ragione: string }[]>([]);

  useEffect(() => {
    const testo = valore.trim();
    if (testo.length < 2) { setOpzioni([]); return; }
    let annullata = false;
    const t = setTimeout(() => {
      adminClientService.list({ q: testo, limit: 8 })
        .then((r) => { if (!annullata) setOpzioni(r.items.map((c) => ({ conto: c.an_conto, ragione: c.company }))); })
        .catch(() => { if (!annullata) setOpzioni([]); });
    }, 250);
    return () => { annullata = true; clearTimeout(t); };
  }, [valore]);

  const filtrate = opzioni.filter((o) => String(o.conto) !== valore.trim());

  return (
    <div className="relative">
      <input
        id="diretto-conto"
        value={valore}
        onChange={(e) => { onChange(e.target.value); setAperta(true); }}
        onFocus={() => setAperta(true)}
        onBlur={() => setTimeout(() => setAperta(false), 150)}
        onKeyDown={(e) => { if (e.key === 'Enter') onInvio(); }}
        placeholder="Cerca per conto, ragione sociale o partita IVA"
        className="w-full h-10 rounded-lg border bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#2B5EA7]/30"
        data-testid="diretto-conto"
      />
      {aperta && filtrate.length > 0 && (
        <ul className="absolute z-20 mt-1 w-full rounded-lg border bg-white shadow-md text-sm max-h-56 overflow-auto">
          {filtrate.map((o) => (
            <li key={o.conto}>
              <button type="button" onMouseDown={() => { onChange(String(o.conto)); setAperta(false); }}
                className="w-full text-left px-3 py-2 hover:bg-gray-50">
                <span className="font-mono">{o.conto}</span> <span className="text-muted-foreground">{o.ragione}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
